import { Icon20DocumentTextOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import sharedBusinessImage from 'img/family-content/empty-block-family-sharing.png';
import sharedBusinessImageDark from 'img/family-content/empty-block-family-sharing-dark.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

export const SharedBusiness = (): ReactElement => {
    const onClick = (): void => {
        xray.send('empty_family-folder_create', { p: 'cloud' });
        toolbarActions.create('familyFolder', 'emptyState', undefined, '', true, true);
    };

    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-shared-business">
            <div className={styles.icon}>
                <Icon20DocumentTextOutline data-qa-id="family-shared-business-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-shared-business-title">
                Добавьте в неё первые документы
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-business-content">Файлы в папке увидят родные, но только те, что есть в подписке</Text>
            <img
                src={isDarkTheme ? sharedBusinessImageDark : sharedBusinessImage}
                alt="Общие дела"
                className={classNames(styles.image, styles.familyImage)}
                data-qa-id="family-shared-business-image"
            />
        </div>
    );
};
